import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import SectionHeader from "components/SectionHeader";
import PageSection from "components/PageSection";
import Image from "components/Image";

import "./About.scss";

const About = ({ className, frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const { anchor, header: rootHeader, subheader: rootSubHeader, description, imageFileNames } = frontmatter;

  return (
    <PageSection className={className} id={anchor}>
      <Row>
        <SectionHeader header={rootHeader} subheader={rootSubHeader} />
      </Row>
      <Row className="justify-content-center">
        <Col lg={8}>
          <p className="about-description">{description}</p>
        </Col>
      </Row>
      {imageFileNames && (
        <Row>
          {imageFileNames.map(({ imageFileName, imageFileAlt }) => (
            <Col md={6} key={imageFileName}>
            <Image fileName={imageFileName} alt={imageFileAlt} />
          </Col>
          ))}
        </Row>
      )}
    </PageSection>
  );
};

About.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

About.defaultProps = {
  className: null,
  frontmatter: null,
};

export default About;
